import { render } from "./VueInput.vue?vue&type=template&id=70c29363&scoped=true"
import script from "./VueInput.vue?vue&type=script&lang=js"
export * from "./VueInput.vue?vue&type=script&lang=js"

import "./VueInput.vue?vue&type=style&index=0&id=70c29363&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c29363"]])

export default __exports__